import React from 'react';
import _ from 'lodash';
import ReactQuill from 'react-quill';
import { Card, Grid, Image, Button, Icon, Popup } from 'semantic-ui-react';
import SocialTable from '../social-table';
import * as countryList from '../../utils/helpers/countries';

const cardStyles = {
  margin: '20px auto',
};

const cardContent = {
  paddingBottom: 0,
};

const noPadding = {
  padding: 0,
  marginBottom: 0,
  border: 0,
};

const thumbnailStyles = {
  height: '50px',
  width: '50px',
};

const influencerBioStyles = {
  height: '150px',
};

const buttonStyles = {
  width: '150px',
};

class InfluencerShortlistEditableCard extends React.PureComponent {
  getMediaLink = () => {
    const { influencer, organisation } = this.props;
    return `${_.get(organisation, 'mediaKitUrl')}/media-kit/${influencer.id}`;
  }

  hasMediaKit = () => {
    const { organisation } = this.props;
    console.log('organisation', organisation);
    return _.get(organisation, 'mediaKitUrl');
  }

  render = () => {
    const { influencer, dataNode, onChange, onSave, onRemove, compact, description } = this.props;
    const country = _.find(countryList.default, ['key', influencer.country]);
    const countryName = (country && country.text) || influencer.country;

    return (
      <Card
        fluid
        style={cardStyles}
      >
        <Card.Content style={cardContent} verticalAlign="middle">
          <Grid padded="horizontally">
            <Grid.Row verticalAlign="middle">
              <Grid.Column width={6} style={noPadding}>
                <div>
                  <Image
                    src={influencer.thumbnail}
                    style={thumbnailStyles}
                    floated="left" size="tiny" shape="circular"
                  />
                  <h3>
                    {influencer.name}
                  </h3>
                  <p className="small light">{influencer.primarySocialHandle}</p>
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <p>{countryName || ''}</p>
              </Grid.Column>
              <Grid.Column width={6} style={noPadding}>
                <SocialTable influencer={influencer} mode={'SHORTLIST'} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
        { !compact &&
        <Card.Content>
          <h4>Influencer Bio</h4>
          <ReactQuill
            value={dataNode ? dataNode.description : description}
            onChange={(e, v) => {
              onChange(influencer.id, e, v);
            }}
          />
        </Card.Content>
        }
        { this.hasMediaKit() &&
        <Card.Content>
          <h3>
              Influencer Media Card
          </h3>
          <p>
            <a href={this.getMediaLink()} target="_blank" rel="noopener noreferrer">Click here to view the influencers demographics</a>
          </p>
        </Card.Content>
        }
        { !compact &&
        <Card.Content>
          <Button content="save" icon="save" floated="right" style={buttonStyles} onClick={onSave} />
          <Button
            content="remove"
            icon="minus circle"
            color="orange"
            style={buttonStyles}
            onClick={() => {
              onRemove(influencer.id);
            }}
          />
        </Card.Content>
        }

        { !compact && (dataNode && dataNode.approvals) &&
        <Card.Content>
          { _.map(dataNode.approvals, approval => (
            <p>{approval.message}&nbsp;
              {
                approval.type === 'APPROVE'
                  ? <Icon name="thumbs outline up" color="green" />
                  : <Icon name="thumbs outline down" color="red" />
              }
            </p>))}
        </Card.Content>
        }
      </Card>
    );
  }
}

export default InfluencerShortlistEditableCard;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-shortlist-editable-card/index.js
 **/